import {Injectable} from '@angular/core';
import {StageService} from '../services/stage.service';
import {ObjectGapHelperService} from '../services/object-gap-helper.service';
import {CollisionService} from '../services/collision/collision.service';
import {ObjectCheckerService} from '../services/object-checker.service';
import {Intersector} from '../services/collision/polygon';

declare let THREE: any;

@Injectable()
export class CloneLocatorService {

  constructor(
    private stage: StageService,
    private objectGapHelperSrvc: ObjectGapHelperService,
    private collisionSrvc: CollisionService,
    private objectCheckerSrvc: ObjectCheckerService,
    private polygonIntersector: Intersector
  ) {
  }

  private getStaticObjects(currentObj) {
    return this.stage.getAllExceptTheObject(currentObj)
      .filter(obj => obj.name === 'Accessory' && obj.name !== 'floor');
  }

  private getFloorObjectPosition(originalObj) {

    const entity = originalObj.userData.entity,
      size = new THREE.Vector3(entity.length, entity.height, entity.width),
      sceneObjects = this.getStaticObjects(originalObj),
      gap = this.objectGapHelperSrvc.getGapBetweenTwoObjects(entity, entity),
      originalPosition = new THREE.Vector3(),
      rotation = new THREE.Quaternion();

    originalObj.getWorldPosition(originalPosition);
    originalObj.getWorldQuaternion(rotation);

    const offsets = [
      new THREE.Vector3(size.x + gap, 0, 0).applyQuaternion(rotation),
      new THREE.Vector3(-size.x - gap, 0, 0).applyQuaternion(rotation),
      new THREE.Vector3(0, 0, size.z + gap).applyQuaternion(rotation),
      new THREE.Vector3(0, 0, -size.z - gap).applyQuaternion(rotation)
    ];

    let i = 0,
      offset,
      collided,
      newPosition;

    for (; i < offsets.length; i++) {
      offset = offsets[i];
      newPosition = originalPosition.clone().add(offset);
      collided = this.polygonIntersector.objectIntersectsOtherObjects(originalObj, sceneObjects, {newPosition});
      if (!collided) {
        return newPosition;
      }
    }

    return null;
  }

  // rework
  private getWallMountableObjectPosition(originalObj) {

    originalObj.updateMatrixWorld();

    var entity = originalObj.userData.entity,
      gap = this.objectGapHelperSrvc.getGapBetweenTwoObjects(entity, entity),
      sceneObjects = this.getStaticObjects(originalObj),
      originalPosition = originalObj.position,
      i = 0,
      isAboveRoof,
      newPosition,
      positions = [
        new THREE.Vector3(entity.length + gap, 0, 0),
        new THREE.Vector3(-entity.length - gap, 0, 0),
        new THREE.Vector3(0, entity.height + gap, 0),
        new THREE.Vector3(0, -entity.height - gap, 0)
      ];

    for (; i < positions.length; i++) {
      newPosition = positions[i].applyMatrix4(originalObj.matrixWorld);
      // isAboveRoof = newPosition.y + entity.height / 2 > this.appSettings.getCeilingHeight();
      // if (isAboveRoof)
      //     continue;
      if (!this.collisionSrvc.isCollide(originalObj, sceneObjects, {
        newPosition: newPosition
      })) {
        return newPosition;
      }
    }

    return null;
  };

  // rework
  private getWallEmbeddableObjectPosition(originalObj) {

    originalObj.updateMatrixWorld();

    var entity = originalObj.userData.entity,
      wallName = originalObj.userData.wall,
      gap = this.objectGapHelperSrvc.getGapBetweenTwoObjects(entity, entity),
      sceneObjectsWithoutThisWall = this.getStaticObjects(originalObj).filter(function (obj) {
        return obj.name !== wallName;
      }),
      originalPosition = originalObj.position,
      i = 0,
      notInsideWall,
      newPosition,
      positions = [
        new THREE.Vector3(entity.length + gap, 0, 0),
        new THREE.Vector3(-entity.length - gap, 0, 0),
        new THREE.Vector3(0, entity.height + gap, 0),
        new THREE.Vector3(0, -entity.height - gap, 0)
      ];

    for (; i < positions.length; i++) {
      newPosition = positions[i].applyMatrix4(originalObj.matrixWorld);
      // notInsideWall = (newPosition.y + entity.height / 2 > appSettings.getCeilingHeight()) || (newPosition.y - entity.height / 2 < 0);
      // if (notInsideWall && (newPosition.y - newPosition.y % 1) !== (originalPosition.y - originalPosition.y % 1))
      //     continue;
      if (!this.collisionSrvc.isCollide(originalObj, sceneObjectsWithoutThisWall, {
        newPosition: newPosition
      })) {
        return newPosition;
      }
    }
    return null;
  };

  public calculatePosition(selectedObj) {
    if (this.objectCheckerSrvc.isWallMountable(selectedObj))
      return this.getWallMountableObjectPosition(selectedObj);
    else if (this.objectCheckerSrvc.isWallEmbeddable(selectedObj))
      return this.getWallEmbeddableObjectPosition(selectedObj);
    else
      return this.getFloorObjectPosition(selectedObj);
  }

}



// WEBPACK FOOTER //
// ./src/app/service/clone-locator.service.ts